import React, { FC } from 'react';
import loading_gif from '../../assets/loader.gif';
// import Layout from '../../components/Layout';

const Home: FC = () => {
  return (
    <div className="modal modal--small is-active loading">
      <img src={loading_gif} alt="loading" />
    </div>
    // <Layout>
    //   <br />
    //   <br />
    //   <br />
    // </Layout>
  );
};

export default Home;
